// extracted by mini-css-extract-plugin
module.exports = {"root":"Clouds_root__1yfTi","right":"Clouds_right__1zEcM","bottomLeft":"Clouds_bottomLeft__2MDVM","topLeft":"Clouds_topLeft__1HTDg"};